
import { CrudEntity, CrudEntityConstructionOptions, PropertyChangeEvent, PropertyMetadata } from '@scisys-uim/uim-common';
import { TEXT_SECTION_METADATA, TextSectionMetadata } from './text-section.metadata';
import { TextSectionBase } from './text-section.model.base';


export interface TextSection extends TextSectionBase {
}

export interface TextSectionTransient { }

export class TextSection extends CrudEntity<TextSection, string, TextSectionTransient> implements TextSectionTransient {
  constructor(source?: Partial<TextSection>, options?: CrudEntityConstructionOptions) {
    super(TEXT_SECTION_METADATA, source, options);
  }

  changeOwnProperty(event: PropertyChangeEvent<any, any>, propertyMetadata?: PropertyMetadata): void {
    console.log(event);
  }
}


